/*
 * Responsible for loading toasts. Acts as a base to other specific toast types
 */
import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from '@shared/modules/toast/services/toast.service';

@Component({
  selector: 'app-toasts-container',
  templateUrl: './toasts-container.component.html',
  styleUrls: ['./toasts-container.component.scss']
})
export class ToastsContainerComponent implements OnInit, OnDestroy {
  private toastSubscription: Subscription;

  constructor(public toastService: ToastService) {}

  ngOnInit() {
    this.toastSubscription = this.toastService.toasts.subscribe(newToast => {});
  }

  ngOnDestroy() {
    this.toastSubscription.unsubscribe();
  }
}
